import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';

export const transformGiftCardDataForTracking = (data: Record<string, any>, listName?: string): EcommerceCartItem => {
  const { vendor, product_type, product_id, product_title, final_price } = data;

  const item: EcommerceCartItem = {
    discount: 0,
    item_bestseller_flag: 'unavailable',
    item_brand: vendor,
    item_category: product_type,
    item_category2: 'unavailable',
    item_category3: 'unavailable',
    item_category4: 'unavailable',
    item_id: product_id,
    item_list_name: listName || 'unavailable',
    item_name: product_title,
    item_review_count: 'unavailable',
    item_review_score: 'unavailable',
    item_variant: 'unavailable',
    price: final_price / 100,
    quantity: 1,
  };

  return item;
};
